// lib
import { createAction } from "@reduxjs/toolkit"; // lib
import queryString from "query-string";
// src
import back from "services/plannings";

export const coursesRequest = createAction("resources/courses/request");
export const coursesSuccess = createAction("resources/courses/success");
export const groupsRequest = createAction("resources/groups/request");
export const groupsSuccess = createAction("resources/groups/success");
export const peopleRequest = createAction("resources/people/request");
export const peopleSuccess = createAction("resources/people/success");
export const roomsRequest = createAction("resources/rooms/request");
export const roomsSuccess = createAction("resources/rooms/success");
// failure action not used per se

const makeFetch = (endpoint, request, success) => (ids) => async (dispatch, getState) => {
  const query = queryString.stringify({ ids }, { arrayFormat: "bracket" });
  await back.request(
    `${endpoint}?${query}`,
    dispatch,
    getState,
    () => dispatch(request()),
    (json) => dispatch(success(json)),
  );
};

export const fetchCourses = makeFetch("/courses", coursesRequest, coursesSuccess);
export const fetchGroups = makeFetch("/groups", groupsRequest, groupsSuccess);
export const fetchPeople = makeFetch("/people", peopleRequest, peopleSuccess);
export const fetchRooms = makeFetch("/rooms", roomsRequest, roomsSuccess);
